import styled from '@emotion/styled';
import Dialog from '../../../utils/utilities/Dialog';

import { IconButton, Tooltip, Divider } from '@mui/material';

import ChatRounded from '@mui/icons-material/ChatRounded';
import SpeakerNotesOffRoundedIcon from '@mui/icons-material/SpeakerNotesOffRounded';

import { BasicFlex, Notes, LabelUpper } from '../../../utils/Common';

import TimelineWithComments from '../../../utils/utilities/Timeline/TimelineWithComments';


const TimelineSection = styled.div`
  padding: 0 1rem;
`

const STNotes = styled(BasicFlex)`
  margin: 0 1rem;
  flex-direction: column;
  align-items: flex-start;
  width: auto;

  * {
    width: 100%;
  }
`

const NoNotes = styled.div`
  /* padding: 1rem; */
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  text-align: center;
  min-height: 6rem;
`

const AppointmentComments = ({comment_count, event}) => {
  return (
    <Dialog
      size="xs"
      toggle={<BasicFlex justify="flex-start" width="auto"><Tooltip title={+comment_count > 0 || event?.service_ticket_notes ? "Notes" :  "No Notes"} ><IconButton sx={{padding: ".2rem"}} size="small">{+comment_count > 0 || event?.service_ticket_notes ? <ChatRounded sx={{fontSize: "1.6rem"}} color="white" /> : <SpeakerNotesOffRoundedIcon sx={{fontSize: "1.6rem"}} htmlColor="#666" />}</IconButton></Tooltip></BasicFlex>}
      title="Appointment Notes"
      useForm={true}
    >
      <STNotes>
        <LabelUpper $normal $size="1.2rem">Service Notes</LabelUpper>
        <Notes>
          {event?.service_ticket_notes ? `"${event?.service_ticket_notes}"` : <NoNotes>No Notes</NoNotes>}
        </Notes>
      </STNotes>

      <Divider sx={{my: "1.4rem", mx: "1rem"}} />

      <TimelineSection>
        <TimelineWithComments title="Appointment Comments" resource="appointments" resource_id={event?.appointment_id} invalidate_queries={[['appointments', 'calendar']]} />
      </TimelineSection>
    </Dialog>
  )
};

export default AppointmentComments;

